{
  if (!window.__pcSliderInit) {
    window.__pcSliderInit = true;

    const setActiveImage = (figure, index) => {
      figure.dataset.active = index;

      figure.querySelectorAll('.product-card__pagination-bar').forEach((button) => {
        const isActive = button.dataset.index === index;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const handle = (event) => {
      const bar = event.target.closest?.('.product-card__pagination-bar');
      if (!bar) return;

      const card = bar.closest('product-card');
      if (!card) return;

      const figure = card.querySelector('.product-card__figure');
      if (!figure) return;

      event.preventDefault();
      event.stopPropagation();

      setActiveImage(figure, bar.dataset.index ?? '0');
    };

    document.addEventListener('click', handle, true);
    document.addEventListener('pointerdown', handle, true);

    let swipeState = null;

    document.addEventListener('pointerdown', (event) => {
      const media = event.target.closest?.('.product-card__media');
      if (!media || event.pointerType === 'mouse') return;

      const figure = media.closest('.product-card__figure');
      if (!figure || !figure.querySelector('.product-card__image--secondary')) return;

      swipeState = {
        media,
        figure,
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY
      };
    }, true);

    document.addEventListener('pointerup', (event) => {
      if (!swipeState || swipeState.pointerId !== event.pointerId) return;

      const deltaX = event.clientX - swipeState.startX;
      const deltaY = event.clientY - swipeState.startY;

      if (Math.abs(deltaX) > 35 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) {
        const nextIndex = deltaX < 0 ? '1' : '0';

        setActiveImage(swipeState.figure, nextIndex);
        swipeState.media.dataset.preventNextClick = 'true';

        event.preventDefault();
        event.stopPropagation();
      }

      swipeState = null;
    }, true);

    document.addEventListener('pointercancel', () => {
      swipeState = null;
    }, true);

    document.addEventListener('click', (event) => {
      const media = event.target.closest?.('.product-card__media[data-prevent-next-click="true"]');
      if (!media) return;

      delete media.dataset.preventNextClick;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }
}
